/**
 * Animated Typing Placeholder for Search
 */

(function() {
  'use strict';

  function initTypingAnimation() {
    const searchInputs = document.querySelectorAll('.search-input, #CollectionSearch, .header-search-input, .mobile-search-input, .search-input-minimal');
    const typingPhrases = [
      "Don't fall asleep - Search instead",
      "It's Friday the Search-teenth",
      "What's your favorite scary query?",
      "Hi, I'm Searchy... Wanna play?",
      "Candyman, Candyman, Candy...",
      "You've got tremors... We've got tees - Search!",
      "It rubs the keyword on its skin",
      "Never grow old... just search",
      "Jason lives... in these results",
      "Come play with results... forever",
      "The power of search compels you!",
      "You're gonna need a bigger cart.",
      "If it trends, we can find it"
    ];

    searchInputs.forEach(input => {
      if (!input) return;

      let currentIndex = 0;
      let isTyping = true;
      let typingInterval;
      let localPhraseIndex = Math.floor(Math.random() * typingPhrases.length); // Random starting phrase

      function typeText() {
        const currentPhrase = typingPhrases[localPhraseIndex];

        if (isTyping) {
          if (currentIndex <= currentPhrase.length) {
            input.setAttribute('placeholder', currentPhrase.substring(0, currentIndex));
            currentIndex++;
          } else {
            // Pause at the end
            setTimeout(() => {
              isTyping = false;
              currentIndex = currentPhrase.length;
            }, 2000);
          }
        } else {
          // Delete text
          if (currentIndex > 0) {
            input.setAttribute('placeholder', currentPhrase.substring(0, currentIndex));
            currentIndex--;
          } else {
            // Move to next phrase
            localPhraseIndex = (localPhraseIndex + 1) % typingPhrases.length;
            // Pause before restarting
            setTimeout(() => {
              isTyping = true;
            }, 500);
          }
        }
      }

      // Only animate when input is not focused and empty
      input.addEventListener('focus', () => {
        clearInterval(typingInterval);
        input.setAttribute('placeholder', ' ');
      });

      input.addEventListener('blur', () => {
        if (input.value === '') {
          currentIndex = 0;
          isTyping = true;
          startTyping();
        }
      });

      function startTyping() {
        typingInterval = setInterval(typeText, 120);
      }

      // Start animation if input is empty
      if (input.value === '') {
        startTyping();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTypingAnimation);
  } else {
    initTypingAnimation();
  }
})();
